<template>
    <el-col>
        <el-button prepend-icon="mdi-upload" @click="uploaderDialog = ture" color="primary" flat>{{ label }}</el-button>
        <el-dialog max-width="500px" persistent v-model="uploaderDialog" scrollable fullscreen>
            <el-card>
                <perfect-scrollbar>
                    <el-card-title class="bg-primary d-flex justify-between">
                        <span class="title text-white">Upload Employee Profile</span>
                        <v-icon @click="uploaderDialog = false">mdi-close</v-icon>
                    </el-card-title>
                    <v-form ref="form">
                        <el-card-text>
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <v-file-input
                                        :prepend-icon="null"
                                        @change="handleFileChange"
                                        chips
                                        show-size
                                        :clearable="false"
                                        v-model="selectedFile"
                                        accept="image/*"
                                        label="Select File"
                                        variant="outlined"
                                    >
                                        <template v-slot:prepend-inner>
                                            <PaperclipIcon stroke-width="1.5" size="22" class="text-medium-emphasis" />
                                        </template>
                                    </v-file-input>
                                </el-col>
                                <el-col :span="24" class="px-4">
                                    <sm-cropper
                                        :stencil-props="{ aspectRatio: 1 / 1 }"
                                        :src="imageUrl"
                                        ref="sm-cropper"
                                    />
                                </el-col>
                                <el-col :span="24" class="d-flex justify-between">
                                    <el-button prepend-icon="mdi-content-cut" flat color="error" @click="crop">
                                        crop
                                    </el-button>
                                </el-col>
                                <el-col :span="24" align="center">
                                    <img class="border" v-if="result" style="max-width: 450px" :src="result" />
                                </el-col>
                            </el-row>
                        </el-card-text>

                        <el-card-actions class="pa-4">
                            <v-spacer></v-spacer>
                            <el-button color="error" @click="uploaderDialog = false">{{ $t('Cancel') }}</el-button>
                            <el-button @click="uploadFile" :disabled="!result" color="secondary" variant="flat">{{
                                $t('Save')
                            }}</el-button>
                        </el-card-actions>
                    </v-form>
                </perfect-scrollbar>
            </el-card>
        </el-dialog>
    </el-col>
</template>

<script>
    export default {
        props: {
            modelValue: null,
            label: {
                type: String,
                default: 'Upload',
            },
            documentID: null,
        },
        data() {
            return {
                uploaderDialog: false,
                uploadedFilename: null,
                result: null,
                selectedFile: null,
                imageUrl: null,
            }
        },
        methods: {
            crop() {
                const { canvas } = this.$refs.sm - cropper.getResult()
                //this.coordinates = coordinates;
                // You able to do different manipulations at a canvas
                // but there we just get a cropped image, that can be used
                // as src for <img/> to preview result
                //var test = canvas.toDataURL();
                //console.log(test)
                this.result = null
                this.result = canvas.toDataURL()
                //this.$refs.sm-cropper.reset();
            },
            handleFileChange() {
                const selectedFile = this.selectedFile[0]
                if (selectedFile) {
                    // Create a FileReader object to read the file
                    const reader = new FileReader()
                    // Set a callback function to handle the file reading operation
                    reader.onload = () => {
                        // Update the imageUrl with the data URL of the selected file
                        this.imageUrl = reader.result
                    }
                    // Start reading the selected file as a data URL
                    reader.readAsDataURL(selectedFile)
                }
            },
            async uploadFile() {
                var documentID = this.documentID
                if (documentID == null) {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Document ID Required',
                    })
                    return
                }
                try {
                    const upload = {
                        data: this.result,
                        documentTypeID: documentID,
                    }
                    const response = await this.$axios.post('FileUploader/Upload', upload)
                    this.uploadedFilename = response.data
                    if (this.uploadedFilename != null) {
                        this.emit('update:modelValue', this.uploadedFilename)
                    } else {
                        this.$swal.fire({
                            icon: 'error',
                            title: 'File Upload Error',
                            text: response.data,
                        })
                    }
                } catch (error) {
                    console.error('Error:', error)
                }
            },
        },
    }
</script>
